import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, MapPinIcon, DollarSignIcon, BuildingIcon, BookmarkIcon, FilterIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const categories = ['All', 'Agentic AI', 'Cybersecurity', 'Cloud Computing', 'Data & Analytics', 'Sales & RevOps', 'UX/UI Design', 'Project Management'];
const jobs = [
// Agentic AI
{
  id: 1,
  title: 'AI Operations Engineer',
  company: 'Google',
  location: 'Remote',
  salary: '$95k - $130k',
  match: 94,
  tags: ['Fair-Chance Employer', 'Remote', 'Health Benefits'],
  posted: '2 hours ago',
  logo: 'https://logo.clearbit.com/google.com',
  category: 'Agentic AI'
}, {
  id: 2,
  title: 'Prompt Engineer',
  company: 'Microsoft',
  location: 'Redmond, WA (Hybrid)',
  salary: '$100k - $140k',
  match: 88,
  tags: ['Mentorship Program', 'Hybrid', 'Health Benefits'],
  posted: '1 day ago',
  logo: 'https://logo.clearbit.com/microsoft.com',
  category: 'Agentic AI'
}, {
  id: 3,
  title: 'ML Operations Specialist',
  company: 'Meta',
  location: 'Remote',
  salary: '$90k - $120k',
  match: 82,
  tags: ['Fair-Chance Employer', 'Remote'],
  posted: '3 days ago',
  logo: 'https://logo.clearbit.com/meta.com',
  category: 'Agentic AI'
},
// Cybersecurity
{
  id: 4,
  title: 'SOC Analyst I',
  company: 'CrowdStrike',
  location: 'Austin, TX',
  salary: '$65k - $80k',
  match: 91,
  tags: ['Training Provided', 'On-site'],
  posted: '5 hours ago',
  logo: 'https://logo.clearbit.com/crowdstrike.com',
  category: 'Cybersecurity'
}, {
  id: 5,
  title: 'Security Operations Associate',
  company: 'Palo Alto Networks',
  location: 'Remote',
  salary: '$70k - $90k',
  match: 87,
  tags: ['Fair-Chance Employer', 'Remote'],
  posted: '1 day ago',
  logo: 'https://logo.clearbit.com/paloaltonetworks.com',
  category: 'Cybersecurity'
}, {
  id: 6,
  title: 'Cybersecurity Analyst',
  company: 'IBM',
  location: 'Washington, DC',
  salary: '$75k - $95k',
  match: 85,
  tags: ['Hybrid', 'Health Benefits'],
  posted: '2 days ago',
  logo: 'https://logo.clearbit.com/ibm.com',
  category: 'Cybersecurity'
},
// Cloud Computing
{
  id: 7,
  title: 'Junior Cloud Engineer',
  company: 'Amazon Web Services',
  location: 'Remote',
  salary: '$75k - $95k',
  match: 92,
  tags: ['Fair-Chance Employer', 'Remote', 'Mentorship Program'],
  posted: 'Just now',
  logo: 'https://logo.clearbit.com/amazon.com',
  category: 'Cloud Computing'
}, {
  id: 8,
  title: 'Cloud Solutions Associate',
  company: 'Accenture',
  location: 'Chicago, IL (Hybrid)',
  salary: '$70k - $90k',
  match: 89,
  tags: ['Training Provided', 'Hybrid'],
  posted: '4 days ago',
  logo: 'https://logo.clearbit.com/accenture.com',
  category: 'Cloud Computing'
}, {
  id: 9,
  title: 'Cloud Infrastructure Associate',
  company: 'Deloitte',
  location: 'New York, NY (Hybrid)',
  salary: '$65k - $85k',
  match: 86,
  tags: ['Training Provided', 'Hybrid'],
  posted: '1 week ago',
  logo: 'https://logo.clearbit.com/deloitte.com',
  category: 'Cloud Computing'
},
// Data & Analytics
{
  id: 10,
  title: 'Data Analyst',
  company: 'Salesforce',
  location: 'Remote',
  salary: '$65k - $85k',
  match: 90,
  tags: ['Fair-Chance Employer', 'Remote'],
  posted: '1 day ago',
  logo: 'https://logo.clearbit.com/salesforce.com',
  category: 'Data & Analytics'
}, {
  id: 11,
  title: 'Junior Data Engineer',
  company: 'Snowflake',
  location: 'San Mateo, CA',
  salary: '$80k - $100k',
  match: 83,
  tags: ['On-site', 'Stock Options'],
  posted: '3 days ago',
  logo: 'https://logo.clearbit.com/snowflake.com',
  category: 'Data & Analytics'
},
// Sales & RevOps
{
  id: 12,
  title: 'Salesforce Administrator',
  company: 'HubSpot',
  location: 'Remote',
  salary: '$60k - $80k',
  match: 88,
  tags: ['Fair-Chance Employer', 'Remote'],
  posted: '2 days ago',
  logo: 'https://logo.clearbit.com/hubspot.com',
  category: 'Sales & RevOps'
}, {
  id: 13,
  title: 'Revenue Operations Analyst',
  company: 'Stripe',
  location: 'San Francisco',
  salary: '$75k - $95k',
  match: 84,
  tags: ['On-site', 'Mentorship Program'],
  posted: '5 days ago',
  logo: 'https://logo.clearbit.com/stripe.com',
  category: 'Sales & RevOps'
},
// UX/UI Design
{
  id: 14,
  title: 'UX Research Associate',
  company: 'Apple',
  location: 'Cupertino, CA (Hybrid)',
  salary: '$75k - $95k',
  match: 79,
  tags: ['Hybrid', 'Training Provided'],
  posted: '1 week ago',
  logo: 'https://logo.clearbit.com/apple.com',
  category: 'UX/UI Design'
}, {
  id: 15,
  title: 'Product Designer',
  company: 'Figma',
  location: 'Remote',
  salary: '$80k - $110k',
  match: 76,
  tags: ['Remote', 'Health Benefits'],
  posted: '4 days ago',
  logo: 'https://logo.clearbit.com/figma.com',
  category: 'UX/UI Design'
},
// Project Management
{
  id: 16,
  title: 'Project Coordinator',
  company: 'McKinsey & Company',
  location: 'New York, NY',
  salary: '$60k - $75k',
  match: 81,
  tags: ['On-site'],
  posted: '2 weeks ago',
  logo: 'https://logo.clearbit.com/mckinsey.com',
  category: 'Project Management'
}, {
  id: 17,
  title: 'Technical Program Manager',
  company: 'JPMorgan Chase',
  location: 'Remote',
  salary: '$85k - $110k',
  match: 78,
  tags: ['Fair-Chance Employer', 'Remote', 'Health Benefits'],
  posted: '3 days ago',
  logo: 'https://logo.clearbit.com/jpmorganchase.com',
  category: 'Project Management'
}];
const featuredPartners = [{
  name: 'Google',
  logo: 'https://logo.clearbit.com/google.com'
}, {
  name: 'Microsoft',
  logo: 'https://logo.clearbit.com/microsoft.com'
}, {
  name: 'Amazon',
  logo: 'https://logo.clearbit.com/amazon.com'
}, {
  name: 'Salesforce',
  logo: 'https://logo.clearbit.com/salesforce.com'
}, {
  name: 'IBM',
  logo: 'https://logo.clearbit.com/ibm.com'
}, {
  name: 'Accenture',
  logo: 'https://logo.clearbit.com/accenture.com'
}, {
  name: 'Deloitte',
  logo: 'https://logo.clearbit.com/deloitte.com'
}, {
  name: 'Stripe',
  logo: 'https://logo.clearbit.com/stripe.com'
}];
export function JobMarketplace() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredJobs = activeCategory === 'All' ? jobs : jobs.filter(j => j.category === activeCategory);
  return <div className="space-y-6 pb-8 h-full flex flex-col" data-id="element-301">
      {/* Header & Search */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-302">
        <div data-id="element-303">
          <h1 className="text-2xl font-bold text-surface-900 tracking-tight" data-id="element-304">
            Career Marketplace
          </h1>
          <p className="text-surface-500 text-sm mt-1" data-id="element-305">
            Curated opportunities from 150+ top employers committed to inclusive
            hiring.
          </p>
        </div>

        <div className="flex items-center gap-2" data-id="element-306">
          <div className="relative w-full md:w-72" data-id="element-307">
            <SearchIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-surface-400" data-id="element-308" />
            <input type="text" placeholder="Search roles, companies..." className="w-full pl-9 pr-4 py-2 bg-white border border-surface-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500" data-id="element-309" />
          </div>
          <button className="p-2 bg-white border border-surface-200 rounded-lg text-surface-600 hover:bg-surface-50 transition-colors" data-id="element-310">
            <FilterIcon className="w-5 h-5" data-id="element-311" />
          </button>
        </div>
      </div>

      {/* Category Tabs */}
      <div className="flex overflow-x-auto pb-2 hide-scrollbar gap-2" data-id="element-312">
        {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === cat ? 'bg-primary-900 text-white' : 'bg-white text-surface-600 border border-surface-200 hover:bg-surface-50'}`} data-id="element-313">
            {cat}
          </button>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 flex-1" data-id="element-314">
        {/* Job Listings */}
        <div className="lg:col-span-2 space-y-4" data-id="element-315">
          {filteredJobs.map((job, i) => <motion.div key={job.id} layout initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.05
        }} className="bg-white p-5 rounded-xl border border-surface-200 hover:border-primary-300 hover:shadow-md transition-all group cursor-pointer" data-id="element-316">
              <div className="flex items-start justify-between gap-4 mb-4" data-id="element-317">
                <div className="flex items-start gap-4" data-id="element-318">
                  <div className="w-12 h-12 rounded-xl bg-white border border-surface-200 flex items-center justify-center overflow-hidden group-hover:border-primary-200 transition-colors p-1.5" data-id="element-319">
                    <img src={job.logo} alt={`${job.company} logo`} className="w-full h-full object-contain" onError={e => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.innerHTML = `<span class="text-xl font-bold text-surface-500">${job.company.charAt(0)}</span>`;
                  }
                }} data-id="element-320" />
                  </div>
                  <div data-id="element-321">
                    <h3 className="text-lg font-semibold text-surface-900 group-hover:text-primary-600 transition-colors" data-id="element-322">
                      {job.title}
                    </h3>
                    <div className="flex flex-wrap items-center gap-2 text-sm text-surface-500 mt-1" data-id="element-323">
                      <span className="flex items-center gap-1" data-id="element-324">
                        <BuildingIcon className="w-3.5 h-3.5" data-id="element-325" /> {job.company}
                      </span>
                      <span data-id="element-326">•</span>
                      <span className="flex items-center gap-1" data-id="element-327">
                        <MapPinIcon className="w-3.5 h-3.5" data-id="element-328" /> {job.location}
                      </span>
                      <span data-id="element-329">•</span>
                      <span className="text-xs" data-id="element-330">{job.posted}</span>
                    </div>
                  </div>
                </div>
                <button className="text-surface-400 hover:text-primary-600 transition-colors flex-shrink-0" data-id="element-331">
                  <BookmarkIcon className="w-5 h-5" data-id="element-332" />
                </button>
              </div>

              <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-333">
                <div className="flex flex-wrap items-center gap-2" data-id="element-334">
                  {job.tags.map((tag, idx) => <span key={idx} className={`px-2.5 py-1 rounded-md text-xs font-medium border ${tag === 'Fair-Chance Employer' ? 'bg-primary-50 text-primary-700 border-primary-100' : 'bg-surface-50 text-surface-600 border-surface-200'}`} data-id="element-335">
                      {tag}
                    </span>)}
                </div>

                <div className="flex items-center gap-4 text-sm" data-id="element-336">
                  <span className="font-medium text-surface-900 flex items-center gap-1" data-id="element-337">
                    <DollarSignIcon className="w-4 h-4 text-surface-400" data-id="element-338" />
                    {job.salary}
                  </span>
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-emerald-50 text-emerald-700 text-xs font-bold border border-emerald-100" data-id="element-339">
                    {job.match}% Match
                  </span>
                </div>
              </div>
            </motion.div>)}
          {filteredJobs.length === 0 && <div className="text-center py-12 bg-white rounded-xl border border-surface-200" data-id="element-340">
              <p className="text-surface-500" data-id="element-341">
                No jobs found in this category.
              </p>
            </div>}
        </div>

        {/* Sidebar */}
        <div className="space-y-6" data-id="element-342">
          {/* Application Tracker */}
          <div className="bg-white p-6 rounded-xl border border-surface-200 shadow-sm" data-id="element-343">
            <h2 className="text-lg font-semibold text-surface-900 mb-4" data-id="element-344">
              Your Applications
            </h2>

            <div className="space-y-4" data-id="element-345">
              <div className="flex items-start gap-3" data-id="element-346">
                <div className="mt-0.5" data-id="element-347">
                  <ClockIcon className="w-5 h-5 text-amber-500" data-id="element-348" />
                </div>
                <div data-id="element-349">
                  <h4 className="text-sm font-medium text-surface-900" data-id="element-350">
                    Cloud Support Associate
                  </h4>
                  <p className="text-xs text-surface-500" data-id="element-351">
                    Amazon • Applied Oct 15
                  </p>
                  <span className="inline-block mt-1 text-xs font-medium text-amber-700 bg-amber-50 px-2 py-0.5 rounded border border-amber-100" data-id="element-352">
                    Under Review
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-353">
                <div className="mt-0.5" data-id="element-354">
                  <CheckCircleIcon className="w-5 h-5 text-emerald-500" data-id="element-355" />
                </div>
                <div data-id="element-356">
                  <h4 className="text-sm font-medium text-surface-900" data-id="element-357">
                    Junior Cloud Engineer
                  </h4>
                  <p className="text-xs text-surface-500" data-id="element-358">
                    Accenture • Interviewing
                  </p>
                  <span className="inline-block mt-1 text-xs font-medium text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-100" data-id="element-359">
                    Interview Scheduled
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-360">
                <div className="mt-0.5" data-id="element-361">
                  <CheckCircleIcon className="w-5 h-5 text-primary-500" data-id="element-362" />
                </div>
                <div data-id="element-363">
                  <h4 className="text-sm font-medium text-surface-900" data-id="element-364">
                    Data Analyst
                  </h4>
                  <p className="text-xs text-surface-500" data-id="element-365">
                    Salesforce • Applied Oct 20
                  </p>
                  <span className="inline-block mt-1 text-xs font-medium text-primary-700 bg-primary-50 px-2 py-0.5 rounded border border-primary-100" data-id="element-366">
                    Application Sent
                  </span>
                </div>
              </div>
            </div>

            <button className="w-full mt-6 py-2 text-sm font-medium text-surface-600 bg-surface-50 hover:bg-surface-100 rounded-lg transition-colors border border-surface-200" data-id="element-367">
              View All Applications
            </button>
          </div>

          {/* Featured Employers */}
          <div className="bg-white p-6 rounded-xl border border-surface-200 shadow-sm" data-id="element-368">
            <h2 className="text-lg font-semibold text-surface-900 mb-4" data-id="element-369">
              Featured Partners
            </h2>
            <div className="grid grid-cols-2 gap-3" data-id="element-370">
              {featuredPartners.map((partner, i) => <div key={i} className="flex flex-col items-center justify-center p-4 rounded-lg border border-surface-100 bg-surface-50 hover:border-primary-200 hover:bg-white transition-colors cursor-pointer" data-id="element-371">
                  <div className="w-10 h-10 rounded-full bg-white border border-surface-200 flex items-center justify-center overflow-hidden mb-2 p-1" data-id="element-372">
                    <img src={partner.logo} alt={`${partner.name} logo`} className="w-full h-full object-contain" onError={e => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.innerHTML = `<span class="text-lg font-bold text-surface-400">${partner.name.charAt(0)}</span>`;
                  }
                }} data-id="element-373" />
                  </div>
                  <span className="text-xs font-medium text-surface-700 text-center truncate w-full" data-id="element-374">
                    {partner.name}
                  </span>
                </div>)}
            </div>
            <button className="w-full mt-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors" data-id="element-375">
              View all 150+ partners
            </button>
          </div>
        </div>
      </div>
    </div>;
}